import { Component, Input, OnDestroy, OnInit, ViewChild, ElementRef } from '@angular/core';
import { MessageService } from 'primeng/api';
import { Subject } from 'rxjs';
import { debounceTime, takeUntil } from 'rxjs/operators';
import { BaseComponent } from '../base/base-component';
import { DonneesBaseService } from '../services/donnees-base-service';
import { ProfilService } from '../services/profil-service';
import { ActivatedRoute, Router } from '@angular/router';
import { AppMainComponent } from '../app.main.component';
import { ConversationEntite } from '../entites/conversation';
import { ConversationService } from '../services/conversation-service';
import { MessageEntite } from '../entites/message';
import Toolbar from 'quill/modules/toolbar';
import { FileUpload } from 'primeng/fileupload';
import { DocumentService } from '../services/document-service';
import { ETypeLien } from '../entites/enums/type-lien-document';
import { Menu } from 'primeng/menu';
import { MenuItem } from 'primeng/api';
import { ConfirmationService } from 'primeng/api';
import { ETypeFichier } from '../entites/enums/type-fichier';
import { DocumentEntite } from '../entites/document';
import { environment } from 'src/environments/environment';
import { QuillEditorComponent } from 'ngx-quill';
import { EmployeEntite } from '../entites/employe';
import { EmployeService } from '../services/employe-service';
import { DialogService } from 'primeng/dynamicdialog';
import { SelectionEmployeComponent } from './selection-employe.component';
import { NotificationService } from '../services/notification-service';
import { HttpEventType } from '@angular/common/http';
import { HeicConverterService } from '../services/heic-converter.service';

@Component({
  selector: 'app-fil-conversation',
  templateUrl: './fil-conversation.component.html',
  styleUrls: ['./fil-conversation.component.scss'],
  providers: [ConversationService, DocumentService]
})
export class FilConversationComponent extends BaseComponent implements OnInit, OnDestroy {
  @Input({ required: true }) conversationId: number;
  conversation: ConversationEntite;
  messages: MessageEntite[];
  newMessage: MessageEntite;
  messageToEdit: MessageEntite;
  isEditing: boolean = false;
  items: MenuItem[];
  menuOptions: MenuItem[];
  status: string = '';
  rappelDate: Date;
  sending: boolean = false;
  employes: EmployeEntite[];
  uploadUrl: string;
  @ViewChild('editor') editor: QuillEditorComponent;
  @ViewChild('fileUpload') _fileUpload: FileUpload;
  @ViewChild('fileUploadMessage') _fileUploadMessage: FileUpload;
  @ViewChild('menu') _menu: Menu;
  @ViewChild('scrollContainer') scrollContainer: ElementRef<HTMLElement>;

  private readonly scrollLoadDebounceMs = 1000;
  private scrollLoadSubject = new Subject<void>();
  private destroy$ = new Subject<void>();
  private loadedMessageIds = new Set<number>();
  private pendingLoadIds = new Set<number>();

  constructor(
    sdb: DonneesBaseService,
    profilService: ProfilService,
    route: ActivatedRoute,
    routerService: Router,
    appMain: AppMainComponent,
    private conversationService: ConversationService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private documentService: DocumentService,
    private employeService: EmployeService,
    private dialogService: DialogService,
    private notificationService: NotificationService,
    private heicConverterService: HeicConverterService
  ) {
    super(sdb, profilService, route, routerService, appMain);
  }

  ngOnInit() {
    this.ResetMessage();
    this.conversationService.ObtenirConversation(this.conversationId).subscribe({
      next: (response) => {
        this.CompleterChargement();
        this.conversation = response.body;
        this.messages = this.conversation.messages;
        console.log(this.conversation);
        this.editor.onFocus.subscribe(() => this.onFocus());
        this.editor.onBlur.subscribe(() => this.onBlur());
        this.onBlur();
        this.menuOptions = [
          {
            label: 'Ajouter un rappel',
            disabled: this.newMessage.dateRappel != null,
            icon: 'pi pi-bell',
            command: () => this.rappel()
          }
        ];
        this.setupScrollLoad();
        setTimeout(() => {
          this.onScroll();
          window.scrollTo(0, document.body.scrollHeight);
        }, 100);
      },
      error: (error) => {
        this.conversationService.errorHandler(error, 'la conversation');
        switch (error.status) {
          case 400:
            this.status = 'La conversation n\'existe pas.';
            break;
          case 403:
            this.status = 'Vous n\'êtes pas autorisé à accéder à cette conversation.';
            break;
          case 404:
            this.status = 'La conversation n\'existe pas.';
            break;
          default:
            this.status = 'Une erreur est survenue lors de la récupération de la conversation.';
        }
        this.CompleterChargement();
      }
    });
  }

  ObtenirEmployes() {
    if (this.employes)
      return;

    this.employes = [];
    this.employeService.ObtenirListe().then((response) => {
      this.employes = response.valeur;
    });
  }

  async sendMessage() {
    if (this.newMessage.texte == '<p></p>') {
      this.messageService.add({ severity: 'warn', summary: 'Attention', detail: 'Vous ne pouvez pas envoyer un message vide', life: 3000 });
      return;
    }

    this.sending = true;

    // Convert HEIC files to JPEG before processing
    const convertedFiles = await this.heicConverterService.convertFiles(this._fileUpload.files as any);

    // Update the file objects to mark converted files and update the UI
    const updatedFiles: File[] = [];
    for (let i = 0; i < this._fileUpload.files.length; i++) {
      const originalFile = this._fileUpload.files[i];
      const convertedFile = convertedFiles[i];
      
      if (convertedFile !== originalFile) {
        // Mark the converted file
        Object.defineProperty(convertedFile, 'convertedFromHeic', { 
          value: true,
          writable: true
        });
        updatedFiles.push(convertedFile);
        console.log(`Converted ${originalFile.name} to ${convertedFile.name}`);
      } else {
        updatedFiles.push(originalFile);
      }
    }

    // Update the files array to reflect the new names
    if (updatedFiles.some((f, i) => f !== this._fileUpload.files[i])) {
      this._fileUpload.files = updatedFiles;
    }

    var documents = convertedFiles.map(f => {
      const reader = new FileReader();
      return new Promise<any>((resolve) => {
        reader.onload = () => {
          resolve({
            nomFichier: f.name,
            dateCreation: new Date(),
            dateModification: new Date(),
            contenu: reader.result.toString().split(',')[1],
            contentType: f.type
          });
        };
        reader.readAsDataURL(f);
      });
    });

    this.newMessage.documents = await Promise.all(documents);

    this.conversationService.AjouterMessage(this.conversation.conversationId, this.newMessage).subscribe({
      next: (response) => {
        this.conversationService.responseHandler(response);
        const dernierMessageLu = this.messages.find(m => m.dernierMessageLu === true);
        if (dernierMessageLu) {
          dernierMessageLu.dernierMessageLu = false;
        }
        this.messages.push(response.body);
        setTimeout(() => this.onScroll(), 200);
        this.ResetMessage();
        this.onBlur();

        this._fileUpload.clear();
        this.sending = false;
      },
      error: (error) => {
        this.conversationService.errorHandler(error, 'le message');
        this.sending = false;
      },
    });
  }


  ResetMessage() {
    this.newMessage = {
      messageId: 0,
      texte: '<p></p>',
      date: new Date(),
      employe: this.profilService.ProfilCourant(),
      statut: null,
      documents: [],
      isEditing: false,
      dateRappel: null,
      rappelEnvoye: false,
      dernierMessageLu: false
    };
  }

  editMessage(message: MessageEntite) {
    var editingMessage = this.messages.find(m => m.isEditing);
    if (editingMessage) {
      this.cancelEditMessage(editingMessage);
    }

    this.messageToEdit = JSON.parse(JSON.stringify(message));
    message.isEditing = true;
  }

  async confirmEditMessage() {
    // Convert HEIC files to JPEG before processing
    const convertedFiles = await this.heicConverterService.convertFiles(this._fileUploadMessage.files as any);

    // Update the file objects to mark converted files and update the UI
    const updatedFiles: File[] = [];
    for (let i = 0; i < this._fileUploadMessage.files.length; i++) {
      const originalFile = this._fileUploadMessage.files[i];
      const convertedFile = convertedFiles[i];
      
      if (convertedFile !== originalFile) {
        // Mark the converted file
        Object.defineProperty(convertedFile, 'convertedFromHeic', { 
          value: true,
          writable: true
        });
        updatedFiles.push(convertedFile);
        console.log(`Converted ${originalFile.name} to ${convertedFile.name}`);
      } else {
        updatedFiles.push(originalFile);
      }
    }

    // Update the files array to reflect the new names
    if (updatedFiles.some((f, i) => f !== this._fileUploadMessage.files[i])) {
      this._fileUploadMessage.files = updatedFiles;
    }

    var documents = convertedFiles.map(f => {
      const reader = new FileReader();
      return new Promise<any>((resolve) => {
        reader.onload = () => {
          resolve({
            nomFichier: f.name,
            dateCreation: new Date(),
            dateModification: new Date(),
            contenu: reader.result.toString().split(',')[1],
            contentType: f.type
          });
        };
        reader.readAsDataURL(f);
      });
    });

    this.messageToEdit.documents = await Promise.all(documents);

    this.conversationService.ModifierMessage(this.messageToEdit.messageId, this.messageToEdit).subscribe({
      next: (response) => {
        var message = this.messages.find(m => m.messageId == this.messageToEdit.messageId);
        message.isEditing = false;
        message.texte = this.messageToEdit.texte;
        message.documents = this.messageToEdit.documents;
        this.conversationService.responseHandler(response);
      },
      error: (error) => {
        this.conversationService.errorHandler(error, 'le message');
      }
    });
  }

  cancelEditMessage(message: MessageEntite) {
    message.isEditing = false;
    message.texte = this.messageToEdit.texte;
    this.messageToEdit = null;
  }

  deleteMessage(message: MessageEntite) {
    this.confirmationService.confirm({
      key: 'confirmDialog',
      message: 'Voulez-vous vraiment supprimer ce message ?',
      accept: () => {
        this.conversationService.SupprimerMessage(message.messageId).subscribe({
          next: (response) => {
            this.messageService.add({ severity: 'info', summary: 'Suppression', detail: 'Le message a été supprimé' });
            this.messages = this.messages.filter(m => m.messageId != message.messageId);
          },
          error: (error) => {
            this.conversationService.errorHandler(error, 'le message');
          }
        });
      }
    });
  }

  obtenirApercu(doc: DocumentEntite[], message: MessageEntite) {
    const images = doc.filter(x => !x.apercu && x.typeFichier == ETypeFichier.Image);
    images.forEach(x => x.loading = true);
    var ids = images.map(x => x.documentId);

    if (ids.length == 0)
      return;

    this.documentService.ObtenirApercus(ETypeLien.Message, ids).subscribe({
      next: res => {
        if (res) {
          message.documents.find(y => y.documentId == parseInt(res.id)).apercu = 'data:image/jpeg;base64,' + res.apercu;
          message.documents.find(y => y.documentId == parseInt(res.id)).loading = false;
        }
      },
      error: err => {
        console.log(err);
      }
    });
  }

  downloadDocument(doc: DocumentEntite) {
    var progress = this.notificationService.showUploadProgress(doc.nomFichier);
    this.documentService.ObtenirApercuCloudflare(doc.cheminFichier).subscribe({
      next: res => {
        if (res.type === HttpEventType.DownloadProgress) {
          progress.next({ progress: Math.round(res.loaded / res.total * 100), success: null });
        }
        if (res.type === HttpEventType.Response) {
          const imageURL = URL.createObjectURL(res.body);
          const link = document.createElement('a')
          link.href = imageURL
          link.download = doc.nomFichier
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
          progress.next({ progress: 100, success: true });
        }
      },
      error: err => {
        progress.next({ progress: 100, success: false });
      }
    });
  }

  /** System employee ID used for automated/system-generated messages. */
  private static readonly SYSTEM_EMPLOYE_ID = 99998;

  isOwner(message: MessageEntite) {
    return this.profilService.ProfilCourant().employeId == message.employe?.employeId;
  }

  /** Returns true if the message was created by the system (employeId 99998). */
  isSystemMessage(message: MessageEntite): boolean {
    return message.employe?.employeId === FilConversationComponent.SYSTEM_EMPLOYE_ID;
  }

  onShowMenu(message: MessageEntite, event: Event) {
    this.items = [
      { label: 'Modifier', icon: 'pi pi-pencil', command: () => this.editMessage(message) },
      { label: 'Retirer le rappel', icon: 'pi pi-bell', command: () => this.retirerRappel(message) },
      { separator: true },
      { label: 'Supprimer', icon: 'pi pi-trash', command: () => this.deleteMessage(message) }
    ];
    this._menu.toggle(event);
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  /** Sets up the debounced scroll-based message loading. */
  private setupScrollLoad() {
    this.scrollLoadSubject.pipe(
      debounceTime(this.scrollLoadDebounceMs),
      takeUntil(this.destroy$)
    ).subscribe(() => this.flushBatchLoad());
  }

  /** Called on scroll. Collects visible message IDs and schedules a batched load after 1 second. */
  onScroll() {
    if (!this.scrollContainer?.nativeElement || !this.messages?.length) return;

    const container = this.scrollContainer.nativeElement;
    const containerRect = container.getBoundingClientRect();
    const messageElements = container.querySelectorAll<HTMLElement>('.message-item');

    messageElements.forEach((el) => {
      const messageId = parseInt(el.getAttribute('data-message-id') ?? '', 10);
      if (isNaN(messageId) || this.loadedMessageIds.has(messageId)) return;

      const rect = el.getBoundingClientRect();
      const isVisible = rect.bottom > containerRect.top && rect.top < containerRect.bottom;
      if (isVisible) this.pendingLoadIds.add(messageId);
    });

    if (this.pendingLoadIds.size > 0) this.scrollLoadSubject.next();
  }

  /** Loads all pending message IDs in a single batched API call. */
  private flushBatchLoad() {
    if (this.pendingLoadIds.size === 0) return;

    const ids = Array.from(this.pendingLoadIds);
    this.pendingLoadIds.clear();

    this.conversationService.ObtenirPlusieursMessages(ids).subscribe({
      next: (response) => {
        this.messages = this.messages.map(m => {
          const message = response.body.find(m2 => m2.messageId === m.messageId);
          if (message) {
            this.loadedMessageIds.add(m.messageId);
            const updatedMessage = { ...message, dernierMessageLu: m.dernierMessageLu };
            this.obtenirApercu(message.documents, updatedMessage);
            return updatedMessage;
          }
          return m;
        });
      },
      error: (err) => this.conversationService.errorHandler(err, 'les messages')
    });
  }

  retirerRappel(message: MessageEntite) {
    this.conversationService.RetirerRappel(message.messageId).subscribe({
      next: (response) => {
        this.messageService.add({ severity: 'info', summary: 'Rappel', detail: 'Le rappel a été retiré' });
        message.dateRappel = null;
      },
      error: (error) => {
        this.conversationService.errorHandler(error, 'le message');
      }
    });
  }

  onFocus() {
    this.isEditing = true;

    const toolbar = this.editor.quillEditor.getModule('toolbar') as Toolbar;
    toolbar.container.style.display = 'block';
    toolbar.container.style.borderTop = "3px solid var(--primary-color)";
    toolbar.container.style.borderLeft = "3px solid var(--primary-color)";
    toolbar.container.style.borderRight = "3px solid var(--primary-color)";
    toolbar.container.style.borderTopLeftRadius = "var(--border-radius)";
    toolbar.container.style.borderTopRightRadius = "var(--border-radius)";
    this.editor.quillEditor.container.style.borderTopLeftRadius = "0px";
    this.editor.quillEditor.container.style.borderTopRightRadius = "0px";
    this.editor.quillEditor.container.style.border = "3px solid var(--primary-color)"
    this.editor.quillEditor.container.style.borderTop = "none";
  }

  onBlur() {
    if (this.newMessage.texte == '<p></p>') {
      this.isEditing = false;
      (this.editor.quillEditor.getModule('toolbar') as Toolbar).container.style.display = 'none';
      this.editor.quillEditor.container.style.border = "1px solid var(--text-color)"
      this.editor.quillEditor.container.style.borderRadius = "var(--border-radius)"
    }
  }

  /** Triggers the file choose dialog for the message upload. */
  triggerFileChoose() {
    this._fileUpload?.choose();
  }

  rappel() {
    this.rappelDate = new Date(new Date().setMonth(new Date().getMonth() + 1));
    this.confirmationService.confirm({
      key: 'ajouterRappel',
      header: 'Ajouter un rappel',
      message: 'Ce rappel sera envoyé à la date spécifiée si il n\'y a pas de réponse d\'un autre membre de la conversation entre cette date et la date d\'expiration de la conversation.',
      accept: () => {
        this.newMessage.dateRappel = this.rappelDate;
      }
    });
  }

  ajouterMembre() {
    this.dialogService.open(SelectionEmployeComponent, {
      header: 'Ajouter un membre',
      width: '50%',
      data: {
        employeId: null
      }
    }).onClose.subscribe((result) => {
      if (result) {
        this.conversationService.AjouterMembreConversation(this.conversation.conversationId, result).subscribe({
          next: (response) => {
            this.conversation.membres.push(response);
            this.messageService.add({ severity: 'info', summary: 'Membre', detail: 'Le membre a été ajouté' });
          },
          error: (error) => {
            this.conversationService.errorHandler(error, 'le membre');
          }
        });
      }
    });
  }

  supprimerMembre(employeId: number) {
    this.conversationService.SupprimerMembreConversation(this.conversation.conversationId, employeId).subscribe({
      next: (response) => {
        this.conversation.membres = this.conversation.membres.filter(m => m.employe.employeId != employeId);
        this.messageService.add({ severity: 'info', summary: 'Membre', detail: 'Le membre a été supprimé' });
      },
      error: (error) => {
        this.conversationService.errorHandler(error, 'le membre');
      }
    });
  }
}